// https://stackoverflow.com/a/54820741
import { useEffect } from "react"

type WindowFocusHandlerProps = {
  cookies: {
    remove: (name: string, options: {}) => null
  }
}

const WindowFocusHandler = ({ cookies }: WindowFocusHandlerProps) => {
  const onFocus = () => {
    // Delete bad cookie
    cookies.remove("__ratel0", { path: "/", domain: ".kaizenreporting.com" })
  }

  const onBlur = () => {}

  useEffect(() => {
    window.addEventListener("focus", onFocus)
    window.addEventListener("blur", onBlur)
    onFocus()
    return () => {
      window.removeEventListener("focus", onFocus)
      window.removeEventListener("blur", onBlur)
    }
  }, [])

  return null
}

export default WindowFocusHandler
